<template>
  <div class="page-container animate-fade-in">
    <PageHeader
      title="Admin Dashboard"
      description="Manage your portfolio content, resume, and messages."
      :breadcrumbs="[{ label: 'Home', to: '/' }, { label: 'Admin' }]"
    />

    <div class="grid sm:grid-cols-2 xl:grid-cols-3 gap-4 mb-8">
      <router-link
        v-for="card in cards"
        :key="card.path"
        :to="card.path"
        class="glass-card p-5 hover:shadow-glass-lg transition-all group"
      >
        <div class="flex items-start gap-4">
          <div class="p-3 rounded-xl bg-primary-muted text-primary group-hover:scale-105 transition-transform">
            <AppIcon :name="card.icon" :size="22" />
          </div>
          <div>
            <h3 class="font-semibold text-foreground">{{ card.title }}</h3>
            <p class="text-sm text-muted mt-1">{{ card.description }}</p>
          </div>
        </div>
      </router-link>
    </div>

    <BaseCard title="Quick actions">
      <div class="flex flex-wrap gap-3 mt-2">
        <BaseButton variant="secondary" :loading="seeding" @click="handleSeed">
          Reset to default content
        </BaseButton>
        <BaseButton variant="ghost" tag="router-link" to="/">View live site</BaseButton>
      </div>
      <p class="text-xs text-muted mt-3">
        Content is stored in Firebase under <code class="text-primary">site/</code>. Changes appear on the live site after saving.
      </p>
    </BaseCard>
  </div>
</template>

<script>
import { useToast } from '@/composables/useToast'
import { seedSiteData } from '@/composables/useSiteData'
import PageHeader from '@/components/layout/PageHeader.vue'
import BaseCard from '@/components/ui/BaseCard.vue'
import BaseButton from '@/components/ui/BaseButton.vue'
import AppIcon from '@/components/ui/AppIcon.vue'

export default {
  name: 'AdminDashboard',
  components: { PageHeader, BaseCard, BaseButton, AppIcon },
  data() {
    return {
      seeding: false,
      cards: [
        { title: 'Profile & Home', description: 'Name, bio, roles, social links, hero stats', path: '/admin/profile', icon: 'User' },
        { title: 'Resume & Skills', description: 'Experience, education, skills, PDF content', path: '/admin/resume', icon: 'FileText' },
        { title: 'Portfolio', description: 'Manage projects and downloads', path: '/admin/portfolio', icon: 'Briefcase' },
        { title: 'Messages', description: 'Contact form submissions', path: '/admin/messages', icon: 'Mail' },
        { title: 'Analytics', description: 'Page visits and traffic overview', path: '/admin/analytics', icon: 'BarChart3' },
      ],
    }
  },
  methods: {
    async handleSeed() {
      if (!window.confirm('Reset all site content to defaults? This overwrites Firebase site data.')) return
      this.seeding = true
      const { success, error } = useToast()
      try {
        await seedSiteData()
        success('Content reset', 'Default site data has been restored.')
      } catch (e) {
        error('Reset failed', 'Could not reset site content.')
      } finally {
        this.seeding = false
      }
    },
  },
}
</script>
